import { generateUtilityClass, generateUtilityClasses } from '@mui/base';

const componentName = 'HigoFormControl';
export const formControlClasses = generateUtilityClasses(componentName, [
  // 'root',
  // 'focused',
  // 'disabled',
  // 'error',
  // 'required',
  // 'asterisk',
  // 'formControl',
  'sizeSmall',
  // 'shrink',
  // 'animated',
  // 'standard',
  // 'filled',
  // 'outlined',
  'horizontal',
]);

export function getFromControlClasses(slot: string): string {
  return generateUtilityClass(componentName, slot);
}
